// Cifra que rueda (video "Mide tu negocio por periodos"): cada digito que cambia entra desde abajo (o desde arriba si
// baja) con un leve desenfoque. Solo anima los digitos que cambian; respeta "reducir movimiento" via CSS.
import { useEffect, useRef, type ReactNode } from 'react';

export function Cifra({ valor, fmt, className }: { valor: number; fmt: (v: number) => string; className?: string }) {
  const texto = fmt(Number.isFinite(valor) ? valor : 0);
  // Lo que se mostro la vez anterior; se actualiza despues de pintar (el render queda puro).
  const prev = useRef<{ texto: string; valor: number } | null>(null);
  useEffect(() => {
    prev.current = { texto, valor };
  }, [texto, valor]);
  const antes = prev.current;
  const sube = !antes || antes.valor <= valor;
  const digitos: ReactNode[] = [...texto].map((c, i) => {
    const anima = !!antes && antes.texto !== texto && antes.texto[i] !== c && /\d/.test(c);
    // La clave cambia con el texto: React vuelve a montar el digito y la animacion corre otra vez.
    return (
      <span key={anima ? `${i}-${texto}` : `${i}`} className={`dg${anima ? (sube ? ' dg-in' : ' dg-baja') : ''}`} style={anima ? { animationDelay: `${i * 18}ms` } : undefined} aria-hidden="true">
        {c}
      </span>
    );
  });
  return (
    <span className={`cifra ${className ?? ''}`} aria-label={texto} role="text">
      {digitos}
    </span>
  );
}

// Indicador de la fila de arriba: valor que rueda y variacion contra el periodo anterior.
export function KpiR({ label, valor, fmt, anterior, menosEsMejor, detalle, tono }: { label: string; valor: number; fmt: (v: number) => string; anterior?: number | null; menosEsMejor?: boolean; detalle?: ReactNode; tono?: 'warn' }) {
  let delta: ReactNode = null;
  if (anterior != null && Number.isFinite(anterior) && anterior !== 0 && Number.isFinite(valor)) {
    const d = ((valor - anterior) / Math.abs(anterior)) * 100;
    const bueno = menosEsMejor ? d <= 0 : d >= 0;
    delta = (
      <span className={Math.abs(d) < 0.5 ? '' : bueno ? 'up' : 'dn'} title="Contra el periodo anterior">
        {d >= 0 ? '▲' : '▼'} {Math.abs(d).toLocaleString('es-CO', { maximumFractionDigits: 1, minimumFractionDigits: 1 })} %
      </span>
    );
  }
  return (
    <div className={`kpi ${tono ?? ''}`}>
      <span className="lbl">{label}</span>
      <Cifra className="v" valor={valor} fmt={fmt} />
      <span className="d">
        <span>{detalle ?? (delta ? 'vs. periodo anterior' : '')}</span>
        {delta}
      </span>
    </div>
  );
}
